import React from 'react';
import { moment, i18n } from '@international/mastodon-i18n';
import T from 'components/T';
import { LicenseOnFile } from 'api/verifications/types';
import { slashDatePattern } from 'lib/dateFormat';

const PREFIX =
  'components.Report.Verification.MatrixVerification.DrivingExperience.enhanced.onFile';

// Fixed width so the length of the real license number is not revealed.
const MASK = '••••';

// issuedDate is a date with no time or zone. moment parses it in local time,
// where `new Date` would read it as UTC and render the previous day west of it.
const formatIssuedDate = (issuedDate: string) => {
  moment.locale(i18n.getLocale());

  return moment(issuedDate).format(slashDatePattern());
};

export interface DrivingExperienceLicensesOnFileProps {
  licenses: LicenseOnFile[];
}

const DrivingExperienceLicensesOnFile = ({
  licenses,
}: DrivingExperienceLicensesOnFileProps) => {
  if (licenses.length === 0) return null;

  return (
    <section className='dee-on-file' data-testid='dee-licenses-on-file'>
      <T value={`${PREFIX}.title`} tag='h3' className='dee-on-file__title' />
      <T
        value={`${PREFIX}.description`}
        tag='p'
        className='dee-on-file__description'
      />

      <ul className='dee-on-file__list'>
        {licenses.map(({ state, lastFour, issuedDate }) => (
          <li className='dee-on-file__item' key={`${state}-${lastFour}`}>
            <span className='dee-on-file__state'>{state}</span>
            <span className='dee-on-file__number'>{`${MASK}${lastFour}`}</span>
            {issuedDate ? (
              <T
                value={`${PREFIX}.issuedDate`}
                tag='span'
                className='dee-on-file__date'
                date={formatIssuedDate(issuedDate)}
              />
            ) : (
              <T
                value={`${PREFIX}.issuedDateUnknown`}
                tag='span'
                className='dee-on-file__date'
              />
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default DrivingExperienceLicensesOnFile;
